import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery, Box, Container, Toolbar } from "@mui/material";
import Drawer from "./Drawer";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "components/@extended/Breadcrumbs";
import bg from "assets/images/images/EsgBackground.png";
import navigation from "menu-items";
import { dispatch, useSelector } from "store";
import { openDrawer } from "store/reducers/menu";
import { DRAWER_WIDTH } from "config";
import { AES, enc } from "crypto-js";
import * as url from "../../store/constant/Endpoints";

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down("xl"));
  const { drawerOpen } = useSelector((state) => state.menu);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);

  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     document.title = document.visibilityState === 'visible'
  //       ? 'Property Management'
  //       : 'Come back soon! You’re missed.';
  //   };
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  let permissionUser = localStorage.getItem("data");

  let decryptedData = null;
  if (permissionUser) {
    try {
      // Code that may throw an exception
      decryptedData = AES.decrypt(
        permissionUser,
        url.encryptionSecret
      ).toString(enc.Utf8);
      // ...
    } catch (error) {
      localStorage.clear();
      window.location.reload();
    }
  }

  const permissionsAssrray =
    decryptedData && JSON.parse(decryptedData)?.user_type;

  //  useEffect(() => {
  //   if (permissionsAssrray === "bank_user") {
  //     setTimeout(() => {
  //       window.location.href = "/payments/all-payments";
  //     }, 1000);
  //   }
  // }, []); // empty dependency array for running the effect only once

  return (
    // <Box sx={{ display: "flex", width: "100%" }}>
    //   <Header open={open} handleDrawerToggle={handleDrawerToggle} />
    //   <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />

    //   <Box
    //     component="main"
    //     sx={{
    //       width: `calc(100% - ${DRAWER_WIDTH}px)`,
    //       flexGrow: 1,
    //       p: { xs: 2, sm: 3 },
    //       backgroundImage: `url(${bg})`,
    //       backgroundRepeat: 'no-repeat',
    //       backgroundPosition: 'center',
    //     }}
    //   >
    //     <Toolbar sx={{ mt: "inherit" }} />
    //     <Container
    //       sx={{
    //         position: "relative",
    //         minHeight: "calc(100vh - 110px)",
    //         display: "flex",
    //         flexDirection: "column",
    //         maxWidth: "2000px !important",
    //       }}
    //     >
    //       <Breadcrumbs navigation={navigation} title />
    //       <Outlet />
    //       <Footer />
    //     </Container>
    //   </Box>
    // </Box>
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} setOpen={setOpen} />
      {/* <Box sx={{ display: open && isMobile ? 'none' : 'flex' }}>
        <Header open={open} handleDrawerToggle={handleDrawerToggle} setOpen={setOpen} />
      </Box> */}
      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />

      <Box
        component="main"
        sx={{
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          flexGrow: 1,
          p: { xs: 1, sm: 1.5 },
          position: 'relative',
          overflow: 'hidden',
          color: open && isMobile ? 'transparent' : 'inherit',
          pointerEvents: open && isMobile ? 'none' : 'auto',
          userSelect: open && isMobile ? 'none' : 'auto',
          "&::before": {
            content: '""',
            position: 'absolute',
            width: '925.9999801766007px',
            height: '933.9999800053403px',
            bottom: '-250px',
            right: '-250px',
            backgroundImage: `url(${bg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
            transform: 'rotate(18.61deg)',
            opacity: 0.1,
            pointerEvents: 'none',
            zIndex: 0,
          },
        }}
      >
        {open && isMobile && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'black',
              opacity: 1,
              zIndex: 10,
            }}
          />
        )}

        <Toolbar sx={{ mt: 'inherit' }} />
        <Container
          sx={{
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '2000px !important',
            zIndex: 1,
            color: open && isMobile ? 'transparent' : 'inherit',
          }}
        >
          <Breadcrumbs navigation={navigation} title />
          <Outlet />
          <Footer />
        </Container>
      </Box>

      {open && isMobile && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '64px',
            backgroundColor: 'black',
            zIndex: 20,
            pointerEvents: 'none',
          }}
        />
      )}
    </Box>

  );
};

export default MainLayout;
